import { ParamsList } from 'parkway-web-common'

export const ItemKeys = {
  allItems: ['Items'] as const,
  listItems: () => [...ItemKeys.allItems, 'listItems'] as const,
  listItem: (filter?: ParamsList) =>
    [...ItemKeys.listItems(), { filter }] as const,
}
